import React from "react";
import { Link } from "react-router-dom";

const ButtonMailto = ({ mailto, label }) => {
    return (
        <Link
            to='#'
            style={{color: "white",
                    justifyContent: 'flex-end',
                    border: "none",
                    background: '#1890ff',
                    paddingTop: '5px',
                    paddingBottom: '5px',
                    paddingLeft: '16px',
                    paddingRight: '16px',
                    borderRadius: 2,
                    cursor: 'pointer'}}
            onClick={(e) => {
                window.location = mailto;
                e.preventDefault();
            }}
        >
            {label}
        </Link>
    );
};

export default ButtonMailto;